import _http_v2 from '@packs/http_requests/_http_v2'
import _http1 from '../../../http_requests/_http_v1'

export default {
    STATIONS_OBJ: undefined,
    STATIONS_LIMIT: 10,
    getStations: async (station_type,mapComponent) =>{
        console.log(station_type);
        
        let type = station_type == "plu" ? 2 : station_type == "quali" ? 5 : 1
        let stations = []

        await _http_v2.request("stations?serializer=complete", 'GET',
            {
                station_type_id: type,
            }).then(data=>{
                //update progress
                stations = data
                
                // mapComponent.updateProgressBar(stations.length,stations.length)
 
            })

        return stations
    },
    // retorna lista de postos. Mantém o proxy
    getAllStations(){
        return this.STATIONS_OBJ.list
    },
    // altera propriedade do posto. Mantém proxy
    setStationProp(station_id, prop, value){
        let index = this.getIndexOfStation(station_id)
        this.STATIONS_OBJ.list[index][prop] = value
    },
    //'toggle' propriedade do posto. Mantém proxy
    toggleStationProp(station_id, prop){
        let index = this.getIndexOfStation(station_id)
        this.STATIONS_OBJ.list[index][prop] = !this.STATIONS_OBJ.list[index][prop]
    },
    //retorna o posto da lista de postos. Mantém o proxy
    getStation(station_id){
        let index = this.getIndexOfStation(station_id)
        return this.STATIONS_OBJ.list[index]
    },
    //recebe lista de postos e garante que apenas estes vao ficar com o parametro 'show' = true
    showOnlyThose(station_ids){
        this.STATIONS_OBJ.list.forEach(station=>{
            station.show = (station_ids.includes(station.id)) ? true : false
        })
    },
    getOnlySelected(){
        return this.STATIONS_OBJ.list.map(x=>x.selected)
    },
    getStationByPrefix(prefixes){
        // console.log(prefixes,this.STATIONS_OBJ.list.map(x=>prefixes.includes(x.prefix)));
        return this.STATIONS_OBJ.list.filter(x=>prefixes.includes(x.prefix))
    },
    getStationById(ids){
        // console.log(prefixes,this.STATIONS_OBJ.list.map(x=>prefixes.includes(x.prefix)));
        return this.STATIONS_OBJ.list.filter(x=>ids.includes(x.id))
    },
    //localiza o posicionamento do posto dentro do array. Importante para manter os comporamentos de proxy
    getIndexOfStation(station_id){
        return this.STATIONS_OBJ.list.findIndex(x=> x.id == station_id)
    },
    countSelected(){
        return this.STATIONS_OBJ.list.filter(x=>x.listItem.isSelected()).length
    },
    validateCount(new_selected_qtd = 0){
        return this.countSelected() + new_selected_qtd <= this.STATIONS_LIMIT
    }
}